// --- SchedulingDashboard.js ---
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import AdminNavBar from '../../components/UI/AdminNavBar';
import Footer from '../../components/UI/Footer';
import VendorSelector from './VendorSelector';
import WeekPicker from './WeekPicker';
import HistoricalEventList from './HistoricalEventList';
import AISuggestionsPanel from './AISuggestionsPanel';
import SchedulePreview from './SchedulePreview';
import WeeklyScheduleCalendar from './WeeklyScheduleCalendar';
import AddToMultipleVendorsModal from './AddToMultipleVendorsModal';
import AddCateringEventModal from './AddCateringEventModal';
import { getFromLocalStorage, deleteFromLocalStorage } from '../../store';
import config from '../../services/apiConfig';
import { apiPaths } from '../../services/apiPath';
import { Container, Button } from 'react-bootstrap';
import './styles.css';
import moment from 'moment';
import SystemWideEventSuggestions from './SystemWideEventSuggestions';
import CurrentYearScheduleSuggesstion from './CurrentYearScheduleSuggesstion';


const SchedulingDashboard = (props) => {
  const [vendorId, setVendorId] = useState(null);
  const [vendorList, setVendorList] = useState([]);
  const [weekData, setWeekData] = useState({ week: null, startDate: null, endDate: null });
  const [selectedEvents, setSelectedEvents] = useState([]);
  const [draftScheduleMap, setDraftScheduleMap] = useState({});
  const [showMultiVendorModal, setShowMultiVendorModal] = useState(false);
  const [eventToAdd, setEventToAdd] = useState(null);
  const [showCateringModal, setShowCateringModal] = useState(false);
  const [selectedVendorIds, setSelectedVendorIds] = useState([]);

  const [isSuperAdminLoggedIn, setIsSuperAdminLoggedIn] = useState(getFromLocalStorage("isSuperAdminLoggedIn") || "false");
  const [isAccountantLoggedIn, setIsAccountantLoggedIn] = useState(getFromLocalStorage("isAccountantLoggedIn") || "false");
  const [isStockAdminLoggedIn, setIsStockAdminLoggedIn] = useState(getFromLocalStorage("isStockAdminLoggedIn") || "false");
  const [isEventCoordinatorLoggedIn, setIsEventCoordinatorLoggedIn] = useState(getFromLocalStorage("isEventCoordinatorLoggedIn") || "false");
  const [historicalRawEvents, setHistoricalRawEvents] = useState([]);
  const [historicalRawDaySales, setHistoricalRawDaySales] = useState([]);

  const [historicalSelected, setHistoricalSelected] = useState([]);
const [systemSelected, setSystemSelected] = useState([]);
const [currentRoster, setCurrentRoster] = useState([]);

  const logout = () => {
    deleteFromLocalStorage("isSuperAdminLoggedIn");
    deleteFromLocalStorage("isEventCoordinatorLoggedIn");
    deleteFromLocalStorage("isAccountantLoggedIn");
    deleteFromLocalStorage("isStockAdminLoggedIn");
    setIsEventCoordinatorLoggedIn("false");
    setIsAccountantLoggedIn("false");
    setIsStockAdminLoggedIn("false");
    setIsSuperAdminLoggedIn("false");
    window.location.reload();
  };

  const handleFetchSystemWideSuggestions = async () => {
  try {
    const response = await fetch(config.BASE_URI + apiPaths.adminData, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        payload: {
          body: {
            query_type: 'fetch_system_wide_event_suggestions',
            
            start_date: moment(weekData.startDate).format("DD MMM YYYY"),
            end_date: moment(weekData.endDate).format("DD MMM YYYY"),
            last_year_start_date: weekData.startDate,
              last_year_end_date: weekData.endDate,
          }
        }
      })
    });

    const data = await response.json();
    if (data.success && Array.isArray(data.events)) {
      // Show this in a modal or a dedicated card list
      console.log("System Suggested Events:", data.events);
    } else {
      console.warn("⚠️ No valid system-wide suggestions returned.");
    }
  } catch (err) {
    console.error("❌ Failed to fetch WTT suggestions:", err);
  }
};

const handleFetchCurrentYearRoster = async () => {
  try {
    const response = await fetch(config.BASE_URI + apiPaths.adminData, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        payload: {
          body: {
            query_type: 'fetch_current_year_schedule',
            
            start_date: moment(weekData.startDate).format("DD MMM YYYY"),
            end_date: moment(weekData.endDate).format("DD MMM YYYY"),
            last_year_start_date: weekData.startDate,
              last_year_end_date: weekData.endDate,
          }
        }
      })
    });

    const data = await response.json();
    if (data.success && Array.isArray(data.events)) {
      // Show this in a modal or a dedicated card list
      console.log("System Suggested Events:", data.events);
    } else {
      console.warn("⚠️ No valid system-wide suggestions returned.");
    }
  } catch (err) {
    console.error("❌ Failed to fetch WTT suggestions:", err);
  }
};

  useEffect(() => {
    if (isSuperAdminLoggedIn === "true" || isEventCoordinatorLoggedIn === "true") {
      fetchVendors();
    } else {
      window.location.href = "/admin";
    }
  }, []);

  useEffect(() => {
    if (vendorList.length > 0 && !vendorId) {
      setVendorId(vendorList[0].user_ptr_id);
    }
  }, [vendorList]);

  useEffect(() => {
    debugger;
    setSelectedEvents([]);
  }, [vendorId]);

  const fetchVendors = async () => {
    try {
      const response = await fetch(config.BASE_URI + apiPaths.adminData, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          payload: {
            body: { query_type: 'get_all_vendors' }
          }
        })
      });

      const data = await response.json();
      if (data.success && Array.isArray(data.vendors)) {
        setVendorList(data.vendors);
      } else {
        console.warn("⚠️ Vendor fetch succeeded but no valid vendor list returned.");
      }
    } catch (error) {
      console.error('❌ Failed to fetch vendors:', error);
    }
  };

  useEffect(() => {
    setSelectedEvents([...historicalSelected, ...systemSelected]);
  }, [historicalSelected, systemSelected]);

  const handleAddToSchedule = (event) => {
    const otherVendors = vendorList.filter(v => v.user_ptr_id !== vendorId);
    if (otherVendors.length === 0) {
      const updatedMap = { ...draftScheduleMap };
      if (!updatedMap[vendorId]) updatedMap[vendorId] = [];
      updatedMap[vendorId] = [...updatedMap[vendorId], event];
      setDraftScheduleMap(updatedMap);
      return;
    }
    setEventToAdd(event);
    setSelectedVendorIds([]);
    setShowMultiVendorModal(true);
  };

  const handleConfirmMultiVendor = () => {
    const updatedMap = { ...draftScheduleMap };

    if (!updatedMap[vendorId]) updatedMap[vendorId] = [];
    updatedMap[vendorId] = [...updatedMap[vendorId], eventToAdd];

    selectedVendorIds.forEach((vId) => {
      if (!updatedMap[vId]) updatedMap[vId] = [];
      updatedMap[vId] = [...updatedMap[vId], eventToAdd];
    });

    setDraftScheduleMap(updatedMap);
    setShowMultiVendorModal(false);
    setEventToAdd(null);
    setSelectedVendorIds([]);
  };

  const handleAddCateringEvent = (cateringEvent) => {
    const updatedMap = { ...draftScheduleMap };
    cateringEvent.vendorIds.forEach((vId) => {
      if (!updatedMap[vId]) updatedMap[vId] = [];
      updatedMap[vId].push(cateringEvent);
    });
    setDraftScheduleMap(updatedMap);
    setShowCateringModal(false);
  };

  return (
    <div className="admin-layout">
      <AdminNavBar
        isSuperAdminLoggedIn={isSuperAdminLoggedIn}
        isEventCoordinatorLoggedIn={isEventCoordinatorLoggedIn}
        isAccountantLoggedIn={isAccountantLoggedIn}
        isStockAdminLoggedIn={isStockAdminLoggedIn}
        logout={logout}
      />

      <Container className="py-5">
        <h2 className="mb-4 fw-bold text-dark"> Event Scheduling Dashboard</h2>

        <div className="mb-4">
          <VendorSelector vendorList={vendorList} onSelect={(vendor) => setVendorId(vendor.user_ptr_id)} />
        </div>

        <div className="mb-4">
          <WeekPicker onChange={setWeekData} />
        </div>

        <Button className="mb-3" variant="outline-primary" onClick={() => setShowCateringModal(true)}>
          Add a Catering Event
        </Button>

        {vendorId && (
          <>
            <div className="mb-4">
            <HistoricalEventList
  key={`vendor-${vendorId}-week-${weekData.week || 0}`}
  vendorId={vendorId}
  weekNumber={weekData.week}
  startDate={moment(weekData.startDate).format("DD MMM YYYY")}
  endDate={moment(weekData.endDate).format("DD MMM YYYY")}
  onSelectionChange={setHistoricalSelected}
  onAddEventToSchedule={handleAddToSchedule}
  onLoadRawHistoricalEvents={setHistoricalRawEvents} // ✅ add this
  onLoadRawHistoricalDaySales={setHistoricalRawDaySales}
/>
            </div>

            <div className="mb-4" >
              <Button className="mb-3" variant="outline-secondary" onClick={handleFetchSystemWideSuggestions}>
  Ask WTT System for Event Suggestions
</Button>

<SystemWideEventSuggestions
  startDate={weekData.startDate}
  endDate={weekData.endDate}
  onSelectionChange={setSystemSelected}
/>

<CurrentYearScheduleSuggesstion
  startDate={weekData.startDate}
  endDate={weekData.endDate}
  onSelectionChange={currentRoster}
/>


            </div>

            <div className="mb-4">
             <AISuggestionsPanel
  key={`ai-${vendorId}-week-${weekData.week || 0}`}
  vendor={vendorList.find(v => v.user_ptr_id === vendorId)}
  weekData={weekData}
/>

            </div>

            <div className="mb-5">
            <SchedulePreview
  key={`preview-${vendorId}-week-${weekData.week || 0}`}
  selectedEvents={selectedEvents}
  vendorId={vendorId}
  weekData={weekData}
  historicalEvents={historicalRawEvents}
  historicalDaySales = {historicalRawDaySales}
/>
            </div>

            <WeeklyScheduleCalendar
              key={`calendar-${vendorId}-week-${weekData.week || 0}`}
              events={draftScheduleMap[vendorId] || []}
              weekStart={weekData.startDate}
            />
          </>
        )}
      </Container>

      <Footer />
        
      <AddToMultipleVendorsModal
        show={showMultiVendorModal}
        onHide={() => setShowMultiVendorModal(false)}
        vendors={vendorList.filter(v => v.user_ptr_id !== vendorId)}
        onConfirm={handleConfirmMultiVendor}
        selectedVendorIds={selectedVendorIds}
        setSelectedVendorIds={setSelectedVendorIds}
        currentVendorId={vendorId}
      />

      <AddCateringEventModal
        show={showCateringModal}
        onClose={() => setShowCateringModal(false)}
        onSave={handleAddCateringEvent}
        vendorList={vendorList}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedTab: state.appReducer.selectedTab,
  vendorData: state.appReducer.vendorData,
  filters: state.appReducer.filters,
  selectedCategory: state.appReducer.selectedCategory,
  loggedIn: state.appReducer.loggedIn,
  smsSent: state.appReducer.smsSent,
  loginModalToggle: state.appReducer.loginModalToggle,
  phone: state.appReducer.phone,
  userId: state.appReducer.userId,
  token: state.appReducer.token,
  username: state.appReducer.username,
  email: state.appReducer.email,
  userAddress: state.appReducer.userAddress,
  userImg: state.appReducer.userImg,
  userLocation: state.appReducer.userLocation,
  currentLatitude: state.appReducer.currentLatitude,
  currentLongitude: state.appReducer.currentLongitude,
  selectedVendorData: state.appReducer.selectedVendorData,
});

export default connect(mapStateToProps)(SchedulingDashboard);
